export const SCREEN_SIZE = {
  MOBILE: '(max-width: 600px)',
  TABLET: '(min-width: 601px)',
  LARGE_TABLET: '@media (max-width: 768px) and (max-width: 1024px)',
  DESKTOP: '(max-width: 1920px)'
}
